<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  created () {
    document.body.addEventListener('click', function (event) {
      if (event.target.id === 'skipintro') {
        let body = document.body
        let grid = document.querySelector('.grid')
        body.classList.remove('animation')
        body.classList.remove('animation--delayed')
        body.offsetHeight
        body.classList.add('animation')

        grid.classList.remove('animation')
        grid.classList.remove('animation--delayed')
        grid.offsetHeight
        grid.classList.add('animation')
      }
    })
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Montserrat:300,400,700');

/* @todo Check license */
@font-face {
  font-family: 'CorporateS';
  src: url('/static/fonts/CorporateS-Italic.otf') format('opentype');
  font-style: italic;
  font-weight: normal;
}

* {
  box-sizing: border-box;
}

body {
  border: 30px solid transparent;
  font-family: 'Montserrat', sans-serif;

  &.animation {
    animation-name: border;
    animation-duration: 2.2s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }

  &.animation--delayed {
    animation-delay: 17.05s;
  }
}

.wrapper {
  max-width: 1592px;
  width: 100%;
  margin: 0 auto;
}

@keyframes border {
  100% {
    border-color: black;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?7d58ecbb